import { Middleware } from "@reduxjs/toolkit";
import { setUser, logout } from "../slices/authSlice";
import { authService } from "../../services/authService";
import { STORAGE_KEYS } from "../../constants";

let isUserDataLoading = false;

export const authMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  // Handle localStorage operations based on auth actions
  switch (action.type) {
    case "auth/loginStart":
      // Clear registration token when starting login
      localStorage.removeItem(STORAGE_KEYS.REGISTRATION_TOKEN);
      break;

    case "auth/loginSuccess":
    case "auth/twoFactorSuccess":
      // Save token to localStorage when login is successful
      if (action.payload?.token) {
        localStorage.setItem(
          STORAGE_KEYS.TOKEN,
          JSON.stringify(action.payload.token)
        );
        // Token refresh is now handled by useTokenManager hook
      }
      break;

    case "auth/logout":
      // Clear all auth-related data from localStorage
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.REGISTRATION_TOKEN);
      sessionStorage.clear();
      // Token refresh cleanup is handled by useTokenManager hook
      break;

    case "auth/setRegistrationToken":
      // Save registration token to localStorage
      if (action.payload) {
        localStorage.setItem(STORAGE_KEYS.REGISTRATION_TOKEN, action.payload);
      }
      break;

    case "auth/tokenRefreshed":
      // Save refreshed token to localStorage
      if (action.payload?.token) {
        localStorage.setItem(
          STORAGE_KEYS.TOKEN,
          JSON.stringify(action.payload.token)
        );
        // Token refresh is managed by useTokenManager hook
      }
      break;
  }

  // Check if user is authenticated but user data is not loaded (only for initializeAuth)
  if (action.type === "auth/initializeAuth") {
    const state = store.getState();
    const { isAuthenticated, user, token } = state.auth;

    if (isAuthenticated && token && !user && !isUserDataLoading) {
      isUserDataLoading = true;
      authService
        .getCurrentUser()
        .then((userData) => {
          store.dispatch(setUser(userData));
          // No automatic token validation
          console.log("User data loaded, no token validation needed");
        })
        .catch((_error) => {
          // If user data loading fails, logout the user
          // BUT skip logout if user is in registration flow
          const isRegistrationFlow = localStorage.getItem(
            STORAGE_KEYS.REGISTRATION_TOKEN
          );
          if (!isRegistrationFlow) {
            store.dispatch(logout());
          }
        })
        .finally(() => {
          isUserDataLoading = false;
        });
    } else if (isAuthenticated && token && user) {
      // User is authenticated and data is loaded - no automatic token validation
      console.log("User authenticated, no token validation needed");
    }
  }

  return result;
};
